var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import DataCacheService from '@/shared/services/DataCacheService';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
var addressMessages = defineMessages({
    Street: { id: 'Street', defaultMessage: 'Street' },
    Number: { id: 'No.', defaultMessage: 'No.' },
    Box: { id: 'Box', defaultMessage: 'Box' },
    Street2: { id: 'Street2', defaultMessage: 'Street 2' },
    PostalCode: { id: 'PostalCode', defaultMessage: 'Postal code' },
    City: { id: 'City', defaultMessage: 'City' },
    Country: { id: 'Country', defaultMessage: 'Country' },
});
var emptyAddress = {
    id: null,
    street1: '',
    street2: '',
    number: '',
    box: '',
    zipCode: '',
    city: '',
    region: null,
    country: null,
};
var formatAddressLines = function (addr, hideCountry, translateCountry) {
    if (!addr)
        return [];
    var lines = [];
    var streetLine = addr.street1 || '';
    if (addr.number)
        streetLine += " ".concat(addr.number);
    if (addr.box)
        streetLine += "/".concat(addr.box);
    if (streetLine.trim())
        lines.push(streetLine.trim());
    if (addr.street2)
        lines.push(addr.street2);
    var cityLine = [addr.zipCode, addr.city].filter(Boolean).join(' ');
    if (cityLine)
        lines.push(cityLine);
    if (!hideCountry && addr.country) {
        lines.push(translateCountry ? translateCountry(addr.country) : addr.country);
    }
    return lines;
};
var EditableAddress = function (_a) {
    var value = _a.value, onSubmit = _a.onSubmit, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b, _c = _a.hideCountry, hideCountry = _c === void 0 ? false : _c;
    var intl = useIntl();
    var countryItems = useMemo(function () {
        var _a;
        var countries = ((_a = DataCacheService.getDataCache()) === null || _a === void 0 ? void 0 : _a.country) || [];
        return countries
            .map(function (c) { return ({
            key: c.code,
            label: intl.formatMessage(listItemMsg('country', c.code, c.name)),
            isCommon: c.isCommon,
        }); })
            .sort(function (a, b) {
            if (a.isCommon !== b.isCommon)
                return a.isCommon ? -1 : 1;
            return a.label.localeCompare(b.label);
        });
    }, [intl]);
    var translateCountry = function (code) { return intl.formatMessage(listItemMsg('country', code, code)); };
    var _d = useState(false), editing = _d[0], setEditing = _d[1];
    var _e = useState(false), saving = _e[0], setSaving = _e[1];
    var _f = useState(value || emptyAddress), form = _f[0], setForm = _f[1];
    var handleEdit = function () {
        if (readOnly)
            return;
        setForm(value || emptyAddress);
        setEditing(true);
    };
    var handleCancel = function () {
        setEditing(false);
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, onSubmit(form)];
                case 2:
                    _a.sent();
                    setEditing(false);
                    return [3 /*break*/, 4];
                case 3:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var updateField = function (field, val) {
        setForm(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = val, _a)));
        });
    };
    if (readOnly) {
        var lines = formatAddressLines(value, hideCountry, translateCountry);
        return (_jsx("div", { children: lines.length > 0
                ? lines.map(function (line, i) { return (_jsxs("span", { children: [i > 0 && _jsx("br", {}), line] }, i)); })
                : null }));
    }
    if (saving) {
        return (_jsx("div", __assign({ className: "react-editable react-editable-saving" }, { children: _jsx("i", { className: "fa fa-spinner fa-spin" }) })));
    }
    if (!editing) {
        var lines = formatAddressLines(value, hideCountry, translateCountry);
        var hasContent = lines.length > 0;
        return (_jsx("a", __assign({ tabIndex: 0, role: "tabpanel", className: "react-editable react-editable-display", style: { display: 'inline-block' }, onClick: handleEdit, onFocus: handleEdit }, { children: hasContent ? (lines.map(function (line, i) { return _jsx("div", { children: line }, i); })) : (_jsx("i", { className: "glyphicon glyphicon-pencil" })) })));
    }
    return (_jsx("div", __assign({ className: "react-editable react-editable-editing react-editable-block" }, { children: _jsxs("div", { children: [_jsxs("div", __assign({ style: { display: 'flex', gap: 4, marginBottom: 4 } }, { children: [_jsx("input", { className: "form-control", style: { flex: 3 }, placeholder: intl.formatMessage(addressMessages.Street), value: form.street1, onChange: function (e) { return updateField('street1', e.target.value); }, autoFocus: true }), _jsx("input", { className: "form-control", style: { flex: 1 }, placeholder: intl.formatMessage(addressMessages.Number), value: form.number, onChange: function (e) { return updateField('number', e.target.value); } }), _jsx("input", { className: "form-control", style: { flex: 1 }, placeholder: intl.formatMessage(addressMessages.Box), value: form.box, onChange: function (e) { return updateField('box', e.target.value); } })] })), _jsx("input", { className: "form-control", style: { marginBottom: 4 }, placeholder: intl.formatMessage(addressMessages.Street2), value: form.street2, onChange: function (e) { return updateField('street2', e.target.value); } }), _jsxs("div", __assign({ style: { display: 'flex', gap: 4, marginBottom: 4 } }, { children: [_jsx("input", { className: "form-control", style: { flex: 2 }, placeholder: intl.formatMessage(addressMessages.PostalCode), value: form.zipCode, onChange: function (e) { return updateField('zipCode', e.target.value); } }), _jsx("input", { className: "form-control", style: { flex: 3 }, placeholder: intl.formatMessage(addressMessages.City), value: form.city, onChange: function (e) { return updateField('city', e.target.value); } })] })), _jsx("div", __assign({ style: { marginBottom: 4 } }, { children: _jsx(AutoComplete, { items: countryItems, value: form.country ? countryItems.find(function (c) { return c.key === form.country; }) || null : null, onChange: function (item) { return updateField('country', item ? item.key : null); }, placeholder: intl.formatMessage(addressMessages.Country), mode: "edit", canClear: true, isSmall: true }) })), _jsxs("div", { children: [_jsx("button", __assign({ type: "button", className: "btn btn-xs btn-inverse", onClick: handleSave }, { children: _jsx("i", { className: "fa fa-check" }) })), _jsx("button", __assign({ type: "button", className: "btn btn-xs btn-default margin5L", onClick: handleCancel }, { children: _jsx("i", { className: "fa fa-times" }) }))] })] }) })));
};
export default EditableAddress;
